import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Card, List, Select, DatePicker, Row, Col, Button, Tooltip, Drawer } from 'antd'
import moment from 'moment';
import CounselingIcon from '../../../assets/icons/counsellar/CounselingIcon.png';
import RegistrationIcon from '../../../assets/icons/counsellar/RegistrationIcon.png';
import Request from '../../../request';
import ReactApexChart from 'react-apexcharts';
import { auto } from 'async';
import { TableComp } from 'sz-react-utils';
const Option = Select.Option
const { RangePicker } = DatePicker
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

class StudentDrawer extends Component {
  state = {
    visible: true,
    studentDetails: [],
    count: 0,
    amount: 0,
    invoiceStatus: '',
    allResults: []
  }

  onClose = () => {
    this.setState({ visible: false, studentDetails: [], count: 0, amount: 0, currencyReceived: "", invoiceStatus: "" })
    setTimeout(() => {
      this.props.onClose()
    }, 50)
  }


  loadStudentDetails = async () => {
    let { universityId, countryId, amount, currencyReceived, invoiceStatus } = this.props
    let response = await Request.getAllUniversityWiseStudentReport({ universityId, countryId, invoiceStatus })

    this.setState({ studentDetails: response.data, count: response.data.length, amount: amount, currencyReceived: currencyReceived, invoiceStatus: invoiceStatus })
  }
  componentDidMount() {
    this.loadStudentDetails()
  }

  constructor(props) {
    super(props)
  }

  // apiRequest = (params)=>{
  //   return new Promise(async(resolve)=>{
  //     let {universityId, countryId} = this.props
  //     let response = await Request.getAllUniversityWiseStudentReport({universityId, countryId});
  //     // console.log(response.data)
  //     resolve(response.data)
  //   })

  // } 

  render() {
    let columns = [
      {
        title: 'S. No',
        key: 'serial Number',
        render: (text, record, index) => (
          <div>{index + 1}</div>
        )
      },
      {
        title: 'Student Name',
        key: 'studentName',
        render: (text, record) => (
          record.studentName ? record.studentName : ""
        )
      },
      {
        title: 'VID',
        key: 'visionId',
        render: (text, record) => (
          record.visionId ? record.visionId : ""
        )
      },
      {
        title: 'PPT No.',
        key: 'passportNumber',
        render: (text, record) => (
          record.studentName ? record.studentName : ""
        )
      },
      {
        title: 'D.O.B',
        key: 'dateOfBirth',
        render: (text, record) => (
          record.dateOfBirth ? moment(record.dateOfBirth).format('DD-MM-YYYY') : ""
        )
      },
      {
        title: 'Student Id',
        key: 'instituteStudentId',
        render: (text, record) => (
          record.instituteStudentId ? record.instituteStudentId : ""
        )
      },
      {
        title: 'University Name',
        key: 'universityInstitutionName',
        render: (text, record) => (
          record.universityInstitutionName ? record.universityInstitutionName : ""
        )
      },
      {
        title: 'Course Name',
        key: 'courseName',
        render: (text, record) => (
          record.courseName ? record.courseName : ""
        )
      },
      {
        title: 'Course Start Date',
        key: 'courseStartDate',
        render: (text, record) => (
          record.courseStartDate ? moment(record.courseStartDate).format('DD-MM-YYYY') : ""
        )
      },
      {
        title: 'Country Name',
        key: 'countryName',
        render: (text, record) => (
          record.countryName ? record.countryName : ""
        )
      },
      {
        title: 'Tution Fee',
        key: 'tutionFee',
        render: (text, record) => (
          record.tutionFee ? record.tutionFee : "NA"
        )
      },
      {
        title: "Visa Approval Date",
        key: 'visaApprovalDate',
        render: (text, record) => (
          record.visaApprovalDate ? moment(record.visaApprovalDate).format('DD-MM-YYYY') : "NA"
        )
      },
      {
        title: "Invoice Generation Date",
        key: 'invoiceGenerationDate',
        render: (text, record) => (
          record.invoiceGenerationDate ? moment(record.invoiceGenerationDate).format('DD-MM-YYYY') : "NA"
        )
      },
      {
        title: `Commission (${this.state.currencyReceived})`,
        key: 'outstandingCommission',
        render: (text, record) => (
          record.invoiceStatus === "Received" ? <p style={{ padding: '5px', background: "green", color: "#fff", textAlign: 'center' }}>{record.invoiceAmount.toFixed(2)}</p> : <p style={{ padding: '5px', background: "red", color: "#fff", textAlign: 'center' }}>{record.outstandingCommission.toFixed(2)}</p>
        )
      }
    ]
    let { visible } = this.state
    return (
      <Drawer
        title={
          <div>
            <React.Fragment>
              Students:- {this.state.count} /  {this.state.invoiceStatus}:- {this.state.currencyReceived} {this.state.amount}
            </React.Fragment>
          </div>
        }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={1200}
        visible={visible}>
        <Card>
          <TableComp
            ref={this.table}
            columns={columns}
            dataSource={this.state.studentDetails}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 10000,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>
      </Drawer>
    )
  }

}


class AllReports extends Component {
  state = {
    countries: [],
    universities: [],
    universityId: '',
    show: false,
    universityWiseReport: [],
    studentUniversityId: '',
    total: 0,
    studentCountryId: '',
    showStudentDrawer: false,
    showUniversityReport: false,
    invoiceStatus: "",
    currencyReceived: "",
    countryId: '',
  };

  constructor(props) {
    super(props)
    this.table = React.createRef();
  }

  componentWillMount() {
  }



  async componentDidMount() {
    this.loadReport()
  }

  loadReport = () => {
    Request.getAllCommissionCountryWiseReport().then(resp => {
      let { allResults } = resp.data;

      this.setState({ show: true, allResults })
      // this.setState({options.xaxis.categories:})
    })
  }


  loadUniversities = () => {
    let params = {
      results: 10000,
      count: 10000
    }

    Request.getUniversities({ ...params }).then(resp => {
      resp.data = resp.data.reduce((temp, vv) => {
        temp.push({ id: vv._id, display: vv.universityInstitutionName })
        return temp
      }, [])
      this.setState({ universities: resp.data })
    })
  }

  loadCountries = () => {
    let params = {
      results: 1000,
      count: 1000,
      businessId: activeUser && activeUser.businessId
    }
    Request.getCountriesWithoutAuth({ ...params }).then(resp => {
      resp.data = resp.data.reduce((temp, vv) => {
        temp.push({ id: vv._id, display: vv.countryName })
        return temp
      }, [])
      this.setState({ countries: resp.data })
    })
  }

  countryNameClick = (countryId) => {
    this.setState({ countryId: countryId && countryId.toString() }, () => {
      this.loadCountryChart(countryId)
    })
  }

  loadUniversityByCountry = (countryId) => {
    Request.loadSimpleUniversitiesByCountry({ universityCountryId: countryId }).then(resp => {
      resp.arr = resp.arr.reduce((temp, vv) => {
        temp.push({ id: vv._id, display: vv.universityInstitutionName })
        return temp
      }, [])
      this.setState({ universities: resp.arr })
    })
  }

  loadCountryChart = (countryId) => {
    Request.getAllCommissionUniversityWiseReport({ countryId: countryId }).then(resp => {
      this.setState({ universityWiseReport: resp.data, showUniversityReport: true })
    })
  }

  loadBranches = () => {
    let params = {
      sortField: 'branchName',
      sortOrder: 'ascend',
      results: 1000,
      count: 1000
    }
    Request.loadBranch({ ...params })
      .then(resp => {
        resp.data = resp.data.reduce((temp, vv) => {
          temp.push({ id: vv._id, display: vv.branchName })
          return temp
        }, [])
        this.setState({ branchs: resp.data });
      })
      .catch(err => {
        console.log(err)
      })
  }

  closeStudentDrawer = () => {
    this.setState({ studentUniversityId: '', studentCountryId: '', invoiceStatus: "", showStudentDrawer: false })
  }

  universityNameClick = (universityId, countryId, total, currencyReceived, invoiceStatus) => {
    this.setState({ studentUniversityId: universityId, studentCountryId: countryId, currencyReceived: currencyReceived, invoiceStatus: invoiceStatus, total: total, showStudentDrawer: true });
  }

  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          from: date[0],
          to: date[1]
        }
      }, () => {
        if (date[0] === undefined) {
          this.loadClaimDeskStates();
        }
      }
    )
  }

  onOk = value => {
    this.loadClaimDeskStates();
  }

  render() {

    let countryTableColumns = [
      {
        title: 'Country Name',
        key: 'countryName',
        render: (text, record) => (
          <Tooltip title="Show Details">

            <Button
              size={'small'}
              onClick={() => this.countryNameClick(record.countryId)}>{text}</Button>
          </Tooltip>
        )
      },
      {
        title: 'Received Commission',
        key: 'receivedCommission',
        render: (text, record) => (
          <div>{record.currencyReceived ? record.currencyReceived : "EUR"}:- {record.receivedCommission.toFixed(2)}</div>
        )
      },
      {
        title: 'Outstanding Commission',
        key: 'outstandingCommission',
        render: (text, record) => (
          <div>{record.currencyReceived ? record.currencyReceived : "EUR"}:- {record.outstandingCommission.toFixed(2)}</div>
        )
      }
    ]

    let columns = [
      {
        title: 'University Name',
        key: 'universityInstitutionName'
      },
      {
        title: 'Received Commission',
        key: 'receivedCommission',
        render: (text, record) => (
          <Tooltip title="Show Details">

            <Button
              size={'small'}
              onClick={() => this.universityNameClick(record.universityId, record.countryId, record.receivedCommission, record.currencyReceived ? record.currencyReceived : "EUR", "Received")} >{record.currencyReceived ? record.currencyReceived : "EUR"}:- {record.receivedCommission}</Button>
          </Tooltip>
        )
      },
      {
        title: "Outstanding Commission",
        key: 'outstandingCommission',
        render: (text, record) => (

          <Tooltip title="Show Details">
            <Button
              size={'small'}
              onClick={() => this.universityNameClick(record.universityId, record.countryId, record.outstandingCommission, record.currencyReceived ? record.currencyReceived : "EUR", "Outstanding")} >{record.currencyReceived ? record.currencyReceived : "EUR"}:- {record.outstandingCommission}</Button>
          </Tooltip>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Reports `}>
        <div className="site-card-wrapper">

          <Card style={{ marginBottom: 10 }}>

            {
              this.state.showStudentDrawer ?
                <StudentDrawer countryId={this.state.studentCountryId} universityId={this.state.studentUniversityId} amount={this.state.total} invoiceStatus={this.state.invoiceStatus} currencyReceived={this.state.currencyReceived} onClose={this.closeStudentDrawer} />
                : null
            }
            {this.state.show ?
              <TableComp
                ref={this.table}
                columns={countryTableColumns}
                dataSource={this.state.allResults}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 10,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
              : null}
            {
              this.state.showUniversityReport ?
                <TableComp
                  ref={this.table}
                  columns={columns}
                  dataSource={this.state.universityWiseReport}
                  extraProps={{ scroll: { x: 900 } }}
                  pagination={{
                    showSizeChanger: true,
                    defaultPageSize: 10,
                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                  }}
                />
                : null
            }
          </Card>

        </div>
      </PageHeaderWrapper>
    );
  }
}

export default AllReports
